import Model from '@/models/Model'

export default class WhRepackingHistoric extends Model {

    //
    wh_selected_products = []

    //
    static includes = [
        "g_user.hr_employee",
        "wh_detail_repacking_historics.wh_item.wh_product",
        "wh_item_to_repackage.wh_product", 
        "wh_warehouse_from.wh_warehouse_type", 
        "wh_warehouse_to.wh_warehouse_type", 
    ]

    /**
     * 
     */
    get g_user_name () {
        return [
            this.g_user.hr_employee.names,
            this.g_user.hr_employee.last_name1,
            this.g_user.hr_employee.last_name2,
        ].join( " " )
    }

    /**
     * 
     */
    get wh_detail_repacking_historics_length () {
        return this.wh_detail_repacking_historics.length
    }
    
    /**
     * 
     */
    get wh_product_name () {
        return this.wh_item_to_repackage.wh_product.name
    }

    /**
     * 
     */
    get wh_warehouse_from_name () {
        return this.wh_warehouse_from.name
    }
    
    /**
     * 
     */
    get wh_warehouse_to_name () {
        return this.wh_warehouse_to.name
    }

    /**
     * { function_description }
     *
     * @param      {<type>}  item    The item
     * @return     {<type>}  { description_of_the_return_value }
     */
    filterItem ( item ) {
        return item.quantity > 0
    }

    /**
     * 
     */
    mapItem ( item ) {
        return {
            quantity    : Number( item.quantity ),
            wh_item_id  : Number( item.wh_item_id ),
        }
    }
    
    /**
     * 
     */
    mapSelected ( item ) {
        return {
            ...item,
            ...item.wh_item,
            ...item.wh_item.wh_product,
        }
    }

    /**
     * 
     */
    reset () {

        //
        this[ "wh_product_to_repackage_id" ]    = this.wh_item_to_repackage.wh_product_id
        this[ "wh_selected_products" ]          = this.wh_detail_repacking_historics.map( this.mapSelected )

        //
        return this
    }

    /**
     * 
     */
    resource () {
        return "wh_repacking_historic"
    }

    /**
     * 
     */
    toCreate () {

        //
        this.items = this.wh_selected_products.map( this.mapItem ).filter( this.filterItem )
        this.is_opened = false

        //
        return this.clean([
            "comment",
            "wh_warehouse_from_id",
            "wh_warehouse_to_id",
            "wh_item_to_repackage_id",
            "is_opened",
            "items",
        ])
    }
}